export const SSR = typeof window === 'undefined';

let node_env: string = process.env.NODE_ENV || 'production';
if (!SSR) {
  const hostname = window.location.hostname;
  // Override environment as needed.
  if (hostname.indexOf('vivechurch-ai-sandbox') !== -1) {
    node_env = 'sandbox';
  }
}

export const IS_PRODUCTION = node_env === 'production';

/** True when NODE_ENV is 'development' (or env overridden to development) */
export const IS_DEVELOPMENT = node_env === 'development';

export const env = node_env;

function getApiUrl() {
  if (typeof window === 'undefined') {
    return null;
  }

  return new URL('/api/admin/', window.location.href).toString();
}

export const apiUrl = getApiUrl();
